module.exports = __webpack_public_path__ + "media/images/emblems/GW-SG-Wildhaus-Alt_Sankt_Johann-109dea1016ec0d4eaee0a89b95cfd489.png";